"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Panel.default;
  }
});
Object.defineProperty(exports, "PanelTitle", {
  enumerable: true,
  get: function get() {
    return _PanelTitle.default;
  }
});
Object.defineProperty(exports, "PanelText", {
  enumerable: true,
  get: function get() {
    return _PanelText.default;
  }
});

var _Panel = _interopRequireDefault(require("./Panel"));

var _PanelTitle = _interopRequireDefault(require("./PanelTitle"));

var _PanelText = _interopRequireDefault(require("./PanelText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }